import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {NgbModal, NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {finalize, tap} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {DisplayPipe} from '../../../../../shared/src/lib/pipes/display.pipe';
import {BaseService} from '../../../../../shared/src/lib/services/base.service';
import {ToastService} from '../../../../../shared/src/lib/services/toast.service';
import {ErrorHandlingService} from '../../../../../shared/src/lib/services/error-handling.service';
import {GenericModalComponent} from '../../../../../shared/src/lib/modals/generic-modal/generic-modal.component';
import {BeachesService} from '../beaches.service';
import {RouterLink} from '@angular/router';
import {DatePipe, NgForOf, NgIf} from '@angular/common';


@Component({
    selector: 'app-beach-submissions-list',
    templateUrl: './submission-list.component.html',
    styleUrls: ['./submission-list.component.scss'],
    providers: [DisplayPipe],
    imports: [
        RouterLink,
        NgIf,
        NgForOf,
        DatePipe,
        NgbPaginationModule,
        DisplayPipe
    ]
})
export class BeachSubmissionsListComponent implements OnInit {
  public loading = true;
  public saving = false;
  public criteria;
  public items;
  public meta;
  public item;
  private count;
  public startDate;
  public endDate;
  public displayFields;
  public serviceObj: any;
  public currentPage;

  constructor(http: HttpClient, public toastr: ToastService, private displayPipe: DisplayPipe,
              private errorHandling: ErrorHandlingService, private modalService: NgbModal,
              public beachService: BeachesService) {
 }

  ngOnInit() {
    this.serviceObj = {
      currentSubmission: {},
      submissions: [],
      user: {},
      loading: false,
      loadingContent: false,
      submitting: false,
      searchParam: {}
    };
    this.beachService.submissionsService.getList<any>({}).pipe(tap((r) => {
       this.loading = false;
       this.serviceObj.submissions = r;
    }),
      finalize(() => {
        this.loading = false;
      })).subscribe();
    this.currentPage = 1;
    console.log(this.serviceObj);
  }

  loadSubmission(id) {
        this.loading = true;
        this.beachService.submissionsService.get<any>(id).pipe(tap((submission) => {
           this.serviceObj.currentSubmission = submission;
        })),
          finalize(() => {
            this.loading = false;
        });
    }

  loadSubmissions() {
    this.loading = true;
    this.beachService.submissionsService.getList<any>(this.serviceObj.searchParam).pipe(tap((submissions) => {
      this.serviceObj.submissions = submissions;
    }),
      finalize(() => {
        this.loading = false;
      })).subscribe();
  }

  switchPage() {
    this.serviceObj.searchParam.page = this.currentPage;
    this.loadSubmissions();
  }

  delete(item, e) {
    e.stopPropagation();
    if (item.status === 'Not Submitted') {
      const modalInstance = this.modalService.open(GenericModalComponent);
      modalInstance.componentInstance.title = 'Please confirm';
      modalInstance.componentInstance.text = 'Are you sure you want to delete?';
      modalInstance.result.then(() => {
        this.beachService.submissionsService.delete(item.globalid).pipe(
          tap(() => this.loadSubmissions())).subscribe();
      });
    } else {
      const modalInstance = this.modalService.open(GenericModalComponent);
      modalInstance.componentInstance.title = 'Warning';
      modalInstance.componentInstance.text = 'Cannot delete submissions after they have been submitted.';
    }
  }
}
